import { MapLayerGroupControl } from '@/views/map/MapLayerManager/MapLayerGroupControl/MapLayerGroupControl';
import { useAppSelector, useAppDispatch } from '@/app/hooks';
import { update as updateMapLayerConfig } from '@/features/mapLayerSlice';
import type { RiskTypeConfig } from '@/views/map/layers/types';
import { LayerType } from '@/views/map/layers/types';
import { useClientTerminology } from '@/views/list/NetworkTerms';
import TagManager from 'react-gtm-module';
import { GoogleEvents } from '@/features/googleEvents';

export const HazardTreeControl = () => {
  const dispatch = useAppDispatch();
  const layerConfig = useAppSelector((s) => s.mapLayer);
  const { getClientTerm } = useClientTerminology();

  const { showHazardTrees } = layerConfig[LayerType.trees] as RiskTypeConfig;
  const isActive = showHazardTrees;

  const toggleHazardTrees = (v: boolean) => {
    TagManager.dataLayer({
      dataLayer: {
        event: v ? GoogleEvents.hazardTreesOn : GoogleEvents.hazardTreesOff, //event name declared during initialization
      },
    });
    return dispatch(
      updateMapLayerConfig({
        [LayerType.trees]: {
          visible: true,
          showHazardTrees: v,
          showDecliningTrees: false,
          showStrikeTrees: false,
          isHazardTreesOnly: true,
        },
      })
    );
  };

  return (
    <MapLayerGroupControl
      icon="HazardTrees"
      title={getClientTerm('map.layerManager.hazardTreesTitle')}
      description="Declining trees with strike potential"
      onVisibilityChange={toggleHazardTrees}
      isGroupVisible={isActive}
      data-testid="hazard-trees-control"
    />
  );
};
